import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const UniformesDefault = Default

export default UniformesDefault;
export const UniformesAdicionar = Adicionar;
export const UniformesEditar = Editar;
